import { AxiosInstance, AxiosResponse } from "axios"

export interface YoastImage {
  width: number
  height: number
  url: string
  type: string
}

export interface YoastHeadJson {
  title: string
  description: string
  canonical: string
  og_locale: string
  og_type: string
  og_title: string
  og_description: string
  og_url: string
  article_publisher: string
  article_published_time: string
  og_image: YoastImage[]
  author: string
  twitter_card: string
  twitter_creator: string
  twitter_site: string
}

export interface BlogData {
  id: number
  date: string
  date_gmt: string
  guid: { rendered: string }
  modified: string
  modified_gmt: string
  slug: string
  status: string
  type: string
  link: string
  title: { rendered: string }
  content: { rendered: string; protected: boolean }
  excerpt: { rendered: string; protected: boolean }
  author: number
  featured_media: number
  comment_status: string
  ping_status: string
  sticky: boolean
  template: string
  format: string
  meta: Record<string, unknown>
  categories: number[]
  tags: number[]
  _links: Record<string, any>
  yoast_head_json: YoastHeadJson
}

export interface GetBlogPropertiesDataResponse extends AxiosResponse {
  data: BlogData[]
}

export function getBlogPropertiesDataAPI(
  axiosInstance: AxiosInstance,
): Promise<GetBlogPropertiesDataResponse> {
  return axiosInstance({
    method: "get",
    url: "https://www.whimstay.com/blog/wp-json/wp/v2/posts?page=1&per_page=10&orderby=date&order=desc",
  }) as Promise<GetBlogPropertiesDataResponse>
}
